import ReactDOM from 'react-dom'
import EventEmitter from 'eventemitter3'

export default class MediaHelper{

  constructor(){
    this.player = {
      playerTimer:null,
      cfInTimer:null,
      cfOutTimer:null,
      currVol:null
    },
    this.events = new EventEmitter()
    this.status = {
      types:{
        0:'init',
        1:'playing',
        2:'cfin',
        3:'cfout',
        4:'finishing'
      },
      type:0
    }
  }

  init(trackSrc){
    return new Promise((resolve,reject) => {
      this.player = document.createElement('audio')
      this.player.src = URL.createObjectURL(trackSrc)
      resolve()
    })
  }

  crossfadeIn(){
    return new Promise((resolve,reject) => {
      this.status.type = 2
      var vol = 0
      this.setVolume(vol)
      this.play()
      this.cfInTimer = setInterval(() => {
        var cfFunc = () => {
          vol = vol + 0.01
          this.currVol = vol
          if(vol > 1){
            this.setVolume(1)
            clearInterval(this.cfInTimer)
            this.cfInTimer = null
            this.status.type = 1
            resolve()
          } else {
            this.setVolume(vol.toFixed(2))
          }
        }
        cfFunc()
      },100)
    })
  }

  crossfadeOut(){
    return new Promise((resolve,reject) => {
      //if crossfading in or out, set curr vol
      let vol = this.currVol
      this.status.type = 3
      this.cfOutTimer = setInterval(() => {
        var cfFunc = () => {
          vol = vol - 0.01
          this.currVol = vol
          if(vol < 0){
            this.setVolume(0)
            //clear cf timer
            clearInterval(this.cfOutTimer)
            this.cfOutTimer = null
            //clear player timer
            clearInterval(this.playerTimer)
            this.playerTimer = null
            this.status.type = 0
            this.stop()
            resolve()
          } else {
            this.setVolume(vol.toFixed(2))
          }
        }
        cfFunc()
      },100)
    })
  }

  startTimer(){
    this.playerTimer = setInterval(() => {
      const length = this.getDuration()
      this.events.emit('length',length)
      const pos = this.getCurrentPosition()
      this.events.emit('position',pos)
      if(pos > -1){
        if(parseInt(pos) + 5 > length && length > 0){
          this.status.type = 4
          this.events.emit('finishing')
          clearInterval(this.playerTimer)
          this.playerTimer = null
        }
      }
    },1000)
  }

  clearTimers(){
    return new Promise((resolve,reject) => {
      clearInterval(this.playerTimer)
      this.playerTimer = null
      clearInterval(this.cfOutTimer)
      this.cfOutTimer = null
      clearInterval(this.cfInTimer)
      this.cfInTimer = null
      resolve()
    })
  }

  play(){
    this.player.play()
  }
  isPlaying(){
    return !this.player.paused
  }
  setVolume(vol){
    this.player.volume = parseFloat(vol)
  }
  getCurrentPosition(){
    return this.player.currentTime
  }
  pause(){
    this.player.pause()
  }
  getDuration(){
    return this.player.duration
  }
  stop(){
    if(typeof this.player !== 'undefined'){
      URL.revokeObjectURL(this.player.src)
      this.player.src = ''
      this.player = null
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/MediaHelper.js